import { Component, OnInit, Input } from '@angular/core';
import { faShoppingCart, faUserCircle, faSignOutAlt } from '@fortawesome/free-solid-svg-icons'

@Component({
  selector: 'app-header-form',
  templateUrl: './header-form.component.html',
  styleUrls: ['./header-form.component.css']
})
export class HeaderFormComponent implements OnInit {
  @Input() count: any
  @Input() config: any
  @Input() settings: any

  userIcon = faUserCircle
  cartIcon = faShoppingCart
  logoutIcon = faSignOutAlt

  constructor() { }

  ngOnInit() {
console.log('-- header form component --')
console.log(this.config)
console.log(this.settings)
  }

}
